import React, { Fragment } from "react"

import { withArticleBreadcrumb } from "./withArticleBreadcrumb"
import { Breadcrumbs, Item } from "./ArticleBreadcrumbStyles"

export const ArticleBreadcrumb = withArticleBreadcrumb(
  ({ breadcrumbs, screen }): JSX.Element => (
    <Breadcrumbs screen={screen}>
      {breadcrumbs?.map(({ title }, index: number) => (
        <Fragment key={title}>
          {index > 0 && <Item separator>|</Item>}
          <Item>{title}</Item>
        </Fragment>
      ))}
    </Breadcrumbs>
  )
)
